<script setup lang="ts"></script>

<template>
  <USeparator class="h-px" />

  <UFooter :ui="{ center: 'mt-0', top: 'border-b border-default' }">
    <p class="text-muted text-sm">
      Jarvis Property Maintenance • © {{ new Date().getFullYear() }}
    </p>
  </UFooter>
</template>
